<template>
  <div>
    <!-- 权限管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tabCss">
      <span
        v-for="(v,i) in tabTitle"
        :key="i"
        :class="typeTab==v.id?'active':''"
        @click="tabFn(v.id)"
      >{{v.title}}</span>
    </div>
    <el-card>
      <!-- 管理员管理开始 -->
      <div class="mangeMant" v-if="typeTab==1">
        <el-row class="manRow">
          <el-col :span="24">
            <el-button @click="addMang()">
              <i class="iconfont icon-jiahao"></i>
              创建账号
            </el-button>
          </el-col>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="date" label="序号" type="index"></el-table-column>
          <el-table-column prop="UserName" label="用户名"></el-table-column>
          <el-table-column prop="title" label="所属角色">
            <template slot-scope="scope">
              {{!scope.row.title?'超管':scope.row.title}}
            </template>
          </el-table-column>
          <el-table-column prop="Login_ip" label="最后登录Ip"></el-table-column>
          <el-table-column prop="Login_Time" label="最后登录时间"></el-table-column>
          <el-table-column prop="Phone" label="手机号"></el-table-column>
          <el-table-column prop="E_mail" label="Email"></el-table-column>
          <el-table-column prop="name" label="真实姓名"></el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button class="colorS" type="text" @click="reserveFn(scope.row)">删除</el-button>
              <el-button type="text" @click="addMang(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="ListChange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 管理员管理结束 -->
      <!-- 角色管理开始 -->
      <div class="mangeMant" v-if="typeTab==2">
        <el-row class="manRow">
          <el-col :span="24">
            <el-button @click="addRoleFn()">
              <i class="iconfont icon-jiahao"></i>
              添加角色
            </el-button>
          </el-col>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="date" label="序号" type="index"></el-table-column>
          <el-table-column prop="title" label="角色名称"></el-table-column>
          <el-table-column prop="description" label="角色描述"></el-table-column>
          <el-table-column prop="address" label="状态">
            <template slot-scope="scope">
              <img src="@/images/scenic/dl.png" alt srcset v-if="scope.row.status=='1'" />
              <img src="@/images/scenic/dh.png" alt srcset v-if="scope.row.status=='2'" />
              <span style="margin-left:1rem;">{{ scope.row.status=='1'?'启用':'禁止'  }}</span>
              <!-- <span>{{scope.row.title}}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button class="colorS" type="text" @click="reserverole(scope.row)">删除</el-button>
              <el-button type="text" @click="rightSetFn(scope.row)">权限设置</el-button>
              <el-button type="text" @click="addRoleFn(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total1}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total1" @current-change="roleChange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
      <!-- 角色管理结束 -->
    </el-card>
    <!-- 管理员添加和详情开始 -->
    <rightManDialog v-if="addinfovisible" ref="addinfoDialog" :UserID="UserID" @UserRoles="UserRole"></rightManDialog>
    <!-- 管理员添加和详情结束 -->
    <!-- 角色添加和修改开始 -->
    <rightManDialog v-if="addrolevisible" ref="addroleDialog" :roleID="roleID" @VisibleClose="VisibleCl"></rightManDialog>
    <!-- 角色添加和修改结束 -->

    <!-- 权限设置开始 -->
    <el-dialog :close-on-click-modal="false"
      title="角色权限"
      :visible.sync="rightDialogVisible"
      :before-close="rightHandleClose"
      width="54%"
      center
      class="autorDialog"
    >
      <el-divider></el-divider>

      <div class="rightSet">
        <div class="rightWorke">
          <div>
            <span>{{Name}}</span>
            <span>该角色用户拥有指定权限</span>
          </div>
          <div class="itemWorke" v-for="(item,index) in limits" :key="index">
            <div>
              <div>{{item.title}}</div>
              <el-switch v-model="item.c" active-color="#246DEB" inactive-color="#E5E5EA" @change="switchCh(item,$event)"></el-switch>
            </div>
            <div>
                <el-checkbox :label="v.id" v-model="v.c" v-for="v in item.son" :key="v.id" @change="CheckBox(item,$event)" >{{v.title}}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="itemRight" style="margin-left:-50px">
        <el-button>清空</el-button>
        <el-button class="btnL" @click="AuthSet">确认添加</el-button>
      </div>
    </el-dialog>
    <!-- 权限设置结束 -->
  </div>
</template>

<script>
import rightManDialog from "./dialog/rightManDialog.vue";
import {List,ScenicUserAll,DeteleRule,DeteleAdministrator,getRoleNodeList,SetAuth} from '@/request/scenic.js'
import {MessageBox,Message} from 'element-ui'
export default {
  components: {
    rightManDialog
  },
  data() {
    return {
      Name:'',
      limitId:'',
      addinfovisible: false, // 管理员添加和详情
      addrolevisible: false, // 角色添加和修改
      rightDialogVisible: false, // 角色权限设置
      typeTab: "1",
      tabTitle: [
        {
          id: 1,
          title: "账号管理"
        },
        {
          id: 2,
          title: "角色管理"
        }
      ],
      tableData: [
      ],
      value: "",
      // 工作台选项
      wordeData: [
        {
          id: 1,
          name: "短信剩余数量"
        },
        {
          id: 2,
          name: "审核短信模板"
        },
        {
          id: 3,
          name: "分销商审核"
        },
        {
          id: 4,
          name: "短信充值审核"
        },
        {
          id: 5,
          name: "App管理"
        },
        {
          id: 6,
          name: "产品列表"
        }
      ],
      checkedWorde: 1, // 工作台选中\
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:10
      },
      UserID:'',
      total:0,
      total1:0,
      limits:[]
    };
  },
  created(){
    this.getList()
  },
  methods: {
    // 权限设置
    AuthSet(){
      let nodeid = ''
      this.limits.map(item=>{
        if(item.c==true){
          nodeid += item.id +',' 
          item.son.map(im=>{
            if(im.c==true){
              nodeid += im.id +',' 
            }
          })
        }
      })
      if (nodeid.length > 0) {
        nodeid = nodeid.substr(0, nodeid.length - 1);
      }
      if(nodeid==''){
        Message.error('请选择权限')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        roleid:this.limitId,
        nodeid:nodeid
      }
      SetAuth(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          this.rightDialogVisible = false
          this.$message.success('权限修改成功')
          this.getListrole()
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    // 添加管理员成功
    UserRole(data){
      this.addinfovisible = false
      if(data==1){
        this.getList()
      }
      this.UserID = ''
    },
    // 权限标题 二级选择
     CheckBox(item,e){
      if(e){
        item.c = true
      }
      for(let i=0;i<item.son.length;i++){
        if(item.son[i].c){
          item.c = true
          this.$forceUpdate()
          return false
        }else{
          item.c = false
        }
      }
      this.$forceUpdate()

    },
    // 权限列表多选
    switchCh(item,e){
      if(e){
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = true
          })
        }
      }else{
        if(item.son!=undefined){
          item.son.map(itm=>{
            itm.c = false
          })
        }
      }
      this.$forceUpdate()
    },
    // 角色管理权限列表
     rightSetFn(row) {
      this.limits = []
      this.limitId = row.id
      this.Name = row.title
      let data = {
        token:window.sessionStorage.getItem('Token')
      }
      getRoleNodeList(data).then(res=>{
          if(res.data.status=='ok'){
            res.data.result.map(item=>{
              if(item.son){
                this.limits.push(item)
              }
            })
            if(row.rules!=''){
              row.rules.split(',').map(item=>{
                  this.limits.map(v=>{
                    if(v.id==item){
                      v.c = true
                    }
                    if(v.son!=undefined){
                      v.son.map(itm=>{
                        if(itm.id==item){
                          itm.c = true
                        }
                      })
                    }
                  })
                })
              }else{
            }
          }
      })
      this.role_id = row.id
      this.rightDialogVisible = true;
    },
    // 删除管理员
    reserveFn(row){
      if(row.title==null){
        this.$message.error('请勿删除超级管理员')
        return false
      }
      MessageBox('此操作将删除该管理员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            userid:row.id
          }
          DeteleAdministrator(data).then(res=>{
            console.log(res)
            if(res.data.status=='yes'){
              this.data.page = 1
              this.total = 0
              this.$message.success('删除成功')
              this.getList()
            }
          })
        }).catch(() => {
                 
       });
    },
    // 删除角色
    reserverole(row){
      MessageBox('此操作将删除该角色, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            id:row.id
          }
          DeteleRule(data).then(res=>{
            if(res.data.status=='yes'){
              this.data.page = 1
              this.total1 = 0
              this.$message.success('删除成功')
              this.getListrole()
            }
          })
        }).catch(() => {
                 
       });
    },
    // 添加角色
    VisibleCl(data){
      if(data=='1'){
        this.getListrole()
      }
      this.addrolevisible = false
      this.roleID = ''
    },
    // 角色分页
    roleChange(e){
      this.data.page = e
      this.getListrole()
    },
    // 管理员分页
    ListChange(e){
      this.data.page = e
      this.getList()
    },
    // 管理员
    getList(){
      ScenicUserAll(this.data).then(res=>{
        if(res.data.status=='yes'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }
      })
    },
    // 角色
    getListrole(){
      List(this.data).then(res=>{
        if(res.data.status=='yes'){
          this.tableData = res.data.result.data
          this.total1 = res.data.result.total
        }
      })
    },
    // 角色权限设置关闭X
    rightHandleClose() {
      this.rightDialogVisible = false;
    },
    // 角色添加和修改
    addRoleFn(row) {
      this.roleID = row
      this.addrolevisible = true;
      this.$nextTick(() => {
        this.$refs.addroleDialog.addRole(row);
      });
    },
    // 管理员添加和详情
    addMang(row) {
      if(row){
        this.UserID = row.id
      }
      this.addinfovisible = true;
      this.$nextTick(() => {
        this.$refs.addinfoDialog.addInfo(row);
      });
    },
    tabFn(i) {
      this.data.page = 1
      this.total = 0
      this.total1 = 0
      this.typeTab = i;
      if(i==2){
        this.getListrole()
      }else{
        this.getList()
      }
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.itemRight {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 30px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}

.rightSet {
  .rightWorke {
    > div:nth-child(1) {
      margin-bottom: 7px;
      > span:nth-child(1) {
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: center;
        color: #000000;
        margin-right: 10px;
      }
    }
    .itemWorke {
      margin-bottom: 17px;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        color: #666666;
        margin-bottom: 5px;
      }
      > div:nth-child(2) {
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        padding: 20px;
        // height: 94px;
        /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #4ecb73;
          border-color: #4ecb73;
        }
        /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* identical to box height */
          color: #666666;
        }
      }
    }
  }
}
.colorS {
  color: #ff4d4f;
}
.mangeMant {
  .manRow {
    text-align: right;
    .el-button {
      box-sizing: border-box;
      margin-bottom: 20px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;

      color: #246deb;
    }
  }
}
.tabCss {
  display: flex;
  margin: 20px 0;
  .active {
    background: #246deb;
    border-radius: 4px;
  }
  span {
    display: block;
    width: 100px;
    height: 40px;
    line-height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-right: 20px;
  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.el-main{
  background: #fff !important;
}
</style>